import { render, staticRenderFns } from "./cDocumentFullNEW.vue?vue&type=template&id=95f558cc&scoped=true"
import script from "./cDocumentFullNEW.vue?vue&type=script&lang=js"
export * from "./cDocumentFullNEW.vue?vue&type=script&lang=js"
import style0 from "./cDocumentFullNEW.vue?vue&type=style&index=0&id=95f558cc&prod&scoped=true&lang=scss"
import style1 from "./cDocumentFullNEW.vue?vue&type=style&index=1&id=95f558cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f558cc",
  null
  
)

export default component.exports